import React from 'react';
import { token } from '@atlaskit/tokens';

export const PageWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div style={{ background: token('elevation.surface', '#fff'), padding: '10px', minWidth: '700px', maxWidth: '1400px', margin: '0 auto' }} data-e2e-customfield-editor-page="true">
      {children}
    </div>
  );
};
